<template>
  <v-app :theme="theme">
    <!-- 1. Envolvemos tudo em um v-layout -->
    <v-layout> 
      
      <!-- 2. O Sidebar (Navigation Drawer) vem para dentro do layout -->
      <app-sidebar v-model="drawer" :mini="mini"></app-sidebar>

      <!-- 3. O App Bar (Navbar) também vem para dentro -->
      <app-navbar @toggle-sidebar="drawer = !drawer" @toggle-theme="toggleTheme"></app-navbar>

      <!-- 4. O Conteúdo Principal é envolvido pelo v-main -->
      <v-main>
        <router-view></router-view>
      </v-main>
      
      <!-- O Footer agora fica fora do v-layout para fixar no rodapé da página inteira -->
    </v-layout>
    <app-footer></app-footer>
  </v-app>
</template>

<script>
import AppNavbar from './components/AppNavbar.vue'
import AppSidebar from './components/AppSidebar.vue'
import AppFooter from './components/AppFooter.vue'

export default {
  name: 'App',
  components: {
    AppNavbar,
    AppSidebar,
    AppFooter
  },
  data() {
    return {
      drawer: true,
      mini: false,
      theme: 'light'
    }
  },
  methods: {
    toggleTheme() {
      this.theme = this.theme === 'light' ? 'dark' : 'light'
    }
  },
  mounted() {
    // Lógica para recolher o menu em telas pequenas (responsividade)
    this.mini = this.$vuetify.display.mobile
    // Opcional: manter o drawer fechado por padrão em telas mobile
    this.drawer = !this.$vuetify.display.mobile 

    window.addEventListener('resize', () => {
      this.mini = this.$vuetify.display.mobile
    })
  }
}
</script>

<style>
/* Adicione um pequeno ajuste para o v-main ter um scroll suave se necessário */
.v-main {
  height: 100vh;
  overflow-y: auto;
}
</style>